import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MyDataService } from 'src/app/services/data/data.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-new-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  private destroyed$ = new Subject<void>();

  @Input() menuButton: boolean;
  @Output() sidenavToggle = new EventEmitter<void>();

  logo:any;
  logo2: any;
  logo3: any;

  constructor(private dataSvc: MyDataService) { }

  ngOnInit(): void {
    const logo = this.dataSvc.getLogo();
    if (logo) {
      this.logo = logo;
    } else {
      this.dataSvc.getLogoObservable().subscribe((value) => {
        this.logo = value;
      });
    }

    const logo2 = this.dataSvc.getLogo2();
    if (logo2) {
      this.logo2 = logo2;
    } else {
      this.dataSvc.getLogo2Observable().subscribe((value) => {
        this.logo2 = value;
      });
    }

    const logo3 = this.dataSvc.getLogo3();
    if (logo3) {
      this.logo3 = logo3;
    } else {
      this.dataSvc.getLogo3Observable().subscribe((value) => {
        this.logo3 = value;
      });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  toggleSidenav() {
    this.sidenavToggle.emit();
  }
}
